import { Environment } from '../utils/environment';

const env = new Environment();

/**
 * Kernel: This Class will be extended by every Module/Class and adds
 *         the element to the Class it has been called in
 *
 * Example: If the Form Class is initialized on element .js-nav with the
 *          selector data-module="Nav" then this.el and this.$el represent the .js-nav element.
 *          When you want to do something with the .js-nav element you can call this.$el
 *
 */
class Kernel
{
    constructor (target)
    {
        this.$document = env.$document;
        this.$window = env.$window;
        this.$html = env.$html;
        this.$body = env.$body;
        this.$header = env.$header;
        this.$el = target.$el;
        this.el = target.el;
        this.headerHeight = this.$header.outerHeight();
    }
}

export default Kernel;



// WEBPACK FOOTER //
// ./app/src/js/modules/Kernel.js